import { render, staticRenderFns } from "./RecepcionComponent.vue?vue&type=template&id=5a7011b2&"
import script from "./RecepcionComponent.vue?vue&type=script&lang=js&"
export * from "./RecepcionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports